import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const FSPBlockEditor = (props) => {
  return (
    <PageBlocks
      title='FSP Session Sale Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='fsp'
      route={props.route}
    />
  )
}

export default FSPBlockEditor
